import { render, staticRenderFns } from "./public-share-layout.vue?vue&type=template&id=bb62466a&scoped=true&"
import script from "./public-share-layout.vue?vue&type=script&lang=js&"
export * from "./public-share-layout.vue?vue&type=script&lang=js&"
import style0 from "./public-share-layout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./public-share-layout.vue?vue&type=style&index=1&id=bb62466a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb62466a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VImg,VSpacer,VToolbar})
